/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const RectangleHorizontal = [
  "svg",
  defaultAttributes,
  [["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2" }]]
];

export { RectangleHorizontal as default };
//# sourceMappingURL=rectangle-horizontal.js.map
